import gql from 'graphql-tag';

export const GET_LEAD = gql`
  query GetLead($leadId: ID) {
    lead(id: $leadId) {
      id
      email
      title
      phone
      businessName
      contact: fullName
    }
  }
`;
